import { render } from "./equipment-data.vue?vue&type=template&id=f6d9d62a&ts=true"
import script from "./equipment-data.vue?vue&type=script&lang=ts"
export * from "./equipment-data.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__